export enum UserRole {
    UMA_PROTECTION = 'uma_protection',
    DATA_MANAGEMENT = 'Data Management',
    CONVERSATION_INSIGHTS = 'Conversation and Insights',
    SYSTEM_ADMINISTRATION = 'System Administration',
    PATIENT_REGISTRY = 'Patient Registry',
}
